<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal"
                 :id="id" :command="command" :status="status" :variant="variant"
                 ref="dialog_form" @onSubmit="onSubmit">


    <b-card-title>Informe o novo código desejado</b-card-title>

    <t-input v-model="form.productionOrderCodeLabel" required  label="Cód. de Fabricação"/>


  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import ProductionOrderService from "@/services/modules/production/ProductionOrder.service";


export default {
  name: "ProductionOrderChangeCodeLabelDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-production-order-change-code-label",
      title: "Alteração de Código de Produção",
      okText: "Alterar Código",
      form: {
        productionOrderId: 0,
        productionOrderCodeLabel: "",
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      variant: "primary",

    }
  },
  props: {
    productionOrderCodeLabel: {
      type: String,
      required: true,
    },
    foreignKeyColumn: {/*Declarado sempre pontualmente em cada Dialog, pois poderá ser fixo ou vindo de props*/
      type: String,
      default: "",
      required: false,
    },
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()

      this.form.productionOrderId = this.primaryKey
      this.form.productionOrderCodeLabel = this.productionOrderCodeLabel

    },

    async onSubmit() {

      this.status = "sending"

      await ProductionOrderService.changeCodeLabel(this.form).then(() => {

        this.itemInserted.value = this.primaryKey
        this.itemInserted.text = this.productionOrderCodeLabel

        this.successInsert()

      })

    }
  }
}
</script>
